import _ from 'lodash';
import moment from 'moment';
import formatCurrency from "format-currency";

class InvoicePreviewModalController {
  constructor($scope, $uibModalInstance, $http, $rootScope) {
      "ngInject";
      this.name = 'ConfirmModal';

      $scope.title = $uibModalInstance.title;
      $scope.subject = $uibModalInstance.subject;
      $scope.message = $uibModalInstance.message;
      $scope.invoiceLoaded = false;

      $scope.invoiceRecommendation = $uibModalInstance.invoiceRecommendation;

      $http.post($rootScope.apiHost+"/api/admin/invoices/preview", $scope.invoiceRecommendation, {withCredentials: true} ).then(function (success) {
        $scope.invoice = success.data;
        $scope.invoiceLoaded = true;
      });

      $scope.cancel = function () {
        $uibModalInstance.cancel();
      };

      $scope.getHoursWorkedForCurrentPeriod = function (lineItem){
        let hours = 0;
        lineItem.timeEntries.forEach((entry) => {
          hours += entry.hours;
        });
        return hours;
      }

      $scope.getAmountForCurrentPeriod = function (lineItem){
        let amount = 0;
        lineItem.timeEntries.forEach((entry) => {
          amount += (entry.hours * lineItem.chargeCode.popRate.rate);
        });
        return amount;
      }

      $scope.currency = function (value) {
        return formatCurrency(value);
      }


      $scope.getTotalHoursWorked = function () {
        let total = 0;
        if($scope.invoice) {
          $scope.invoice.invoiceLineItems.forEach((li) => {
            total += this.getHoursWorkedForCurrentPeriod(li);
          });
        }

        return total;
      }

      $scope.getTotalCurrentDollars = function () {
        let total = 0;
        if($scope.invoice && $scope.invoice.invoiceLineItems) {
          $scope.invoice.invoiceLineItems.forEach((li) => {
            total += $scope.getAmountForCurrentPeriod(li);
          });
        }

        return total;
      }

      $scope.getTotalCumulativeHoursWorked = function () {
        let total = 0;
        if($scope.invoice) {
          $scope.invoice.invoiceLineItems.forEach((li) => {
            total += li.cumulativeHoursWorked;
          });
        }

        return total;
      }

      $scope.getTotalCumulativeDollars = function () {
        let total = 0;
        if($scope.invoice) {
          $scope.invoice.invoiceLineItems.forEach((li) => {
            total += li.cumulativeDollars;
          });
        }

        return total;
      }

  }





}

export default InvoicePreviewModalController;



// WEBPACK FOOTER //
// ./client/common/modals/InvoicePreviewModal/invoicePreviewModal.controller.js